// src/components/NoLicense.js
// Shown when a user navigates to a module that is not licensed for the active entity.
import React from 'react';
import { FaLock } from 'react-icons/fa';
import { t, useLanguage } from '../useTranslations';
import './NoLicense.css';

const NoLicense = () => {
  useLanguage();
  return (
    <div className="no-license-container">
      <div className="no-license-card">
        <FaLock className="no-license-icon" />
        <h2 className="no-license-heading">{t('modules.administration.licenses.noLicenseHeading')}</h2>
        <p className="no-license-message">{t('modules.administration.licenses.noLicenseMessage')}</p>
      </div>
    </div>
  );
};

export default NoLicense;
